// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-radio-group {
  width: 100%;
  border-radius: 5px;
  padding: 5px;
  display: block;
}
ion-radio-group ion-item {
  background: #ffffff;
  border-radius: var(--radius-default);
  border-bottom: var(--outline-default);
}
ion-radio-group ion-item:first-child {
  border-top: var(--outline-default);
}

.price {
  font-size: 14px;
  color: var(--ion-color-black);
  font-weight: 400;
  text-align: end;
}

ion-label {
  font-size: 14px;
  text-transform: uppercase;
}

ion-icon {
  color: var(--ion-color-primary);
  height: 20px;
  width: 20px;
}

app-tag {
  display: inline-block;
}

.pfand {
  font-size: 10px;
}

ion-checkbox {
  --background: transparent;
  --background-checked: #1ea45a;
  --border-color: rgba(30, 164, 90, 0.45);
  --border-color-checked: #1ea45a;
  --border-width: 1px;
  --checkmark-color: #0f2a18;
  --checkmark-width: 3px;
  --border-radius: 3px;
  --size: 20px;
}

ion-checkbox::part(container) {
  background: transparent;
}

ion-checkbox.checkbox-checked::part(container) {
  background: #1ea45a;
  border-color: #1ea45a;
}

ion-checkbox.checkbox-checked::part(mark) {
  color: #0f2a18;
}`, "",{"version":3,"sources":["webpack://./src/app/components/article-option-group-checkbox/article-option-group-checkbox.component.scss"],"names":[],"mappings":"AAAA;EACC,WAAA;EACA,kBAAA;EACA,YAAA;EACA,cAAA;AACD;AACC;EACC,mBAAA;EACA,oCAAA;EACA,qCAAA;AACF;AACE;EACC,kCAAA;AACH;;AAIA;EACC,eAAA;EACA,6BAAA;EACA,gBAAA;EACA,eAAA;AADD;;AAIA;EACC,eAAA;EACA,yBAAA;AADD;;AAIA;EACC,+BAAA;EACA,YAAA;EACA,WAAA;AADD;;AAIA;EACC,qBAAA;AADD;;AAIA;EACC,eAAA;AADD;;AAIA;EACC,yBAAA;EACA,6BAAA;EACA,uCAAA;EACA,+BAAA;EACA,mBAAA;EACA,0BAAA;EACA,sBAAA;EACA,oBAAA;EACA,YAAA;AADD;;AAIA;EACC,uBAAA;AADD;;AAIA;EACC,mBAAA;EACA,qBAAA;AADD;;AAIA;EACC,cAAA;AADD","sourcesContent":["ion-radio-group {\n\twidth: 100%;\n\tborder-radius: 5px;\n\tpadding: 5px;\n\tdisplay: block;\n\n\tion-item {\n\t\tbackground: #ffffff;\n\t\tborder-radius: var(--radius-default);\n\t\tborder-bottom: var(--outline-default);\n\n\t\t&:first-child {\n\t\t\tborder-top: var(--outline-default);\n\t\t}\n\t}\n}\n\n.price {\n\tfont-size: 14px;\n\tcolor: var(--ion-color-black);\n\tfont-weight: 400;\n\ttext-align: end;\n}\n\nion-label {\n\tfont-size: 14px;\n\ttext-transform: uppercase;\n}\n\nion-icon {\n\tcolor: var(--ion-color-primary);\n\theight: 20px;\n\twidth: 20px;\n}\n\napp-tag {\n\tdisplay: inline-block;\n}\n\n.pfand {\n\tfont-size: 10px;\n}\n\nion-checkbox {\n\t--background: transparent;\n\t--background-checked: #1ea45a;\n\t--border-color: rgba(30, 164, 90, 0.45);\n\t--border-color-checked: #1ea45a;\n\t--border-width: 1px;\n\t--checkmark-color: #0f2a18;\n\t--checkmark-width: 3px;\n\t--border-radius: 3px;\n\t--size: 20px;\n}\n\nion-checkbox::part(container) {\n\tbackground: transparent;\n}\n\nion-checkbox.checkbox-checked::part(container) {\n\tbackground: #1ea45a;\n\tborder-color: #1ea45a;\n}\n\nion-checkbox.checkbox-checked::part(mark) {\n\tcolor: #0f2a18;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
